const API_BASE_URL = 'https://neo-v2-eight.vercel.app'

export const apiFetch = (path, options) => fetch(`${API_BASE_URL}${path}`, options)

export { API_BASE_URL }
